import { IS24ContactForm, IS24ContactFormHeading } from '@dreamstack/feature-components/src/contactForm/IS24ContactForm'
import { SimpleImage } from '@dreamstack/feature-components/src/layout/SimpleImage'
import { BodyText, Css_HeadingH2_tw } from '@dreamstack/feature-components/src/layout/Texts'
import { useTranslation } from '@dreamstack/i18n'
import { clsxMerge } from '@dreamstack/util'
import type { FunctionComponent } from 'react'

// Class constants (exported for reuse/testing)
export const IS24ContactFormBlock_TwoColumnContainer_tw =
  'flex flex-col md:flex-row md:-mb-px-80 ml:-mb-px-96'
export const IS24ContactFormBlock_Column_base_tw =
  'flex-1 flex flex-col max-w-full overflow-hidden py-px-48 md:p-px-48 md:pb-px-96 ml:pb-px-128'
export const IS24ContactFormBlock_Column_left_tw =
  'relative overflow-visible md:pl-0'
export const IS24ContactFormBlock_Column_right_tw = 'md:pr-0'
export const IS24ContactFormBlock_LeftBg_tw =
  'bg-accentroAquaVeryLight-full -z-10 w-[100vw] absolute h-full -mr-px-24 right-0 top-0 md:mr-0'
export const IS24ContactFormBlock_FakeH2_tw = clsxMerge(
  Css_HeadingH2_tw,
  'mb-px-24'
)

// Functional wrappers
const TwoColumnContainer = (props: React.HTMLAttributes<HTMLDivElement>) => (
  <div
    {...props}
    className={clsxMerge(
      IS24ContactFormBlock_TwoColumnContainer_tw,
      props.className
    )}
  />
)
const StyledColumn = ({
  left,
  className,
  children,
}: {
  left?: boolean
  className?: string
  children?: React.ReactNode
}) => (
  <div
    className={clsxMerge(
      IS24ContactFormBlock_Column_base_tw,
      left
        ? IS24ContactFormBlock_Column_left_tw
        : IS24ContactFormBlock_Column_right_tw,
      className
    )}
  >
    {children}
  </div>
)
const FakeH2 = ({
  children,
  className,
}: {
  children?: React.ReactNode
  className?: string
}) => (
  <h3 className={clsxMerge(IS24ContactFormBlock_FakeH2_tw, className)}>
    {children}
  </h3>
)
const LeftSideFullBackgroundContainer = (
  props: React.HTMLAttributes<HTMLDivElement>
) => (
  <div
    {...props}
    className={clsxMerge(IS24ContactFormBlock_LeftBg_tw, props.className)}
  />
)

export const IS24ContactFormBlock: FunctionComponent<
  React.PropsWithChildren<{}>
> = () => {
  const t = useTranslation()
  return (
    <TwoColumnContainer>
      {/* TODO: Localize */}
      <StyledColumn left>
        <LeftSideFullBackgroundContainer />
        <div className="h-full flex flex-col">
          <IS24ContactFormHeading style={{ visibility: 'hidden' }} />
          <FakeH2>{t('accentro:is24.contact')}</FakeH2>
          <BodyText>
            ACCENTRO Real Estate AG
            <br />
            Kantstraße 44/45
            <br />
            D-10625 Berlin
            <br />
            <br />
            Tel.: 030 / 887 181 7628
            <br />
            Fax: 030 / 887 181 49
            <br />
            <br />
            partner@accentro.de
            <br />
            www.accentro.de
          </BodyText>
          <div className="h-px-128 w-full mt-px-32 max-w-[515px] md:mt-px-96 md:max-w-[540px]">
            <SimpleImage
              src="/static/images/logo-acc-is24.svg"
              alt="Accentro and Immoscout24 Logo"
              aspectRatio={191 / 31}
              cover={false}
            ></SimpleImage>
          </div>
        </div>
      </StyledColumn>
      <StyledColumn left={false}>
        <IS24ContactForm />
      </StyledColumn>
    </TwoColumnContainer>
  )
}
